export const english = {
  "Valid till": "Valid till",
  get: "get",
  Sold: "Sold",
  "Delete your account": "Delete your account",
  "Track Your Order": "Track Your Order",
  "Enter your order id": "Enter your order id",
  "Search Order": "Search Order",
  Available: "Available",
  "Your order is": "Your order is",
  "Your total price must be more then coupon amount":
    "Your total price must be more then coupon amount",
  "You can use this ID to track your order later":
    "You can use this ID to track your order later",
  "Cart item remove successfully": "Cart item remove successfully",
  "Theme Mode": "Theme Mode",
  "Search for products or store...": "Search for products or store...",
  "not now": "not now",
  "Search for medicine or store...": "Search for medicine or store...",
  "Suggested Searches": "Suggested Searches",
  "Search for grocery or store...": "Search for grocery or store...",
  "Extra on Every Add Fund": "Extra on Every Add Fund",
  "fund to get max of": "fund to get max of",
  "If product is not available": "If product is not available",
  "Has  paid by your wallet.": "Has  paid by your wallet.",
  "Wallet Payment": "Wallet Payment",
  "Track your Products": "Track your Products",
  "Start a new message": "Start a new message",
  "Do you want to use now?": "Do you want to use now?",
  "Choose Payment Method": "Choose Payment Method",
  "(Choose Payment Method)": "(Choose Payment Method)",
  "Pay after service": "Pay after service",
  Use: "Use",
  "Paid by wallet": "Paid by wallet",
  "Now you can track your products easily whenever you want.":
    "Now you can track your products easily whenever you want.",
  "Label As": "Label As",
  "out of limits": "out of limits",
  "You have balance in  your wallet": "You have balance in  your wallet",
  "Personal Details": "Personal Details",
  "Shopping Cart": "Shopping Cart",
  "You have Saved": "You have Saved",
  "more for free delivery": "more for free delivery",
  "Checking theme and rtl": "Checking theme and rtl",
  "I’ll Pick It Up MySelf": "I’ll Pick It Up MySelf",
  "Most Tipped": "Most Tipped",
  Custom: "Custom",
  "Download ON": "Download ON",
  "No items added in your cart. Please add product to your cart list.":
    "No items added in your cart. Please add product to your cart list.",
  "GET IT ON": "GET IT ON",
  "Add Payment Method": "Add Payment Method",
  "Save this Address": "Save this Address",
  "Become a store owner": "Become a store owner",
  "Search for items or store...": "Search for items or store...",
  Stores: "Stores",
  "Filter Search Results": "Filter Search Results",
  "Your cart is empty": "Your cart is empty",
  Your: "Your",
  "e-Commerce !": "e-Commerce !",
  "Venture Starts Here": "Venture Starts Here",
  "A module has been selected.": "A module has been selected.",
  "Select the type of stores for your order":
    "Select the type of stores for your order",
  "Search location here...": "Search location here...",
  "Login required.": "Login required.",
  Seller: "Seller",
  Admin: "Admin",
  "Delivery Man": "Delivery Man",
  "New delivery address selected.": "New delivery address selected.",
  "Download the Seller App": "Download the Seller App",
  "Download the deliveryman App": "Download the deliveryman App",
  "Download the Driver App": "Download the Driver App",
  "Best Reviewed Items": "Best reviewed items",
  "Featured categories": "Featured categories",
  "Best Store Nearby": "Best Store Nearby",
  "New Arrival Stores": "New Arrival Stores",
  "New Arrival": "New Arrival",
  "Popular Stores": "Popular Stores",
  "Login with": "Login with",
  "Please give a phone number": "Please give a phone number",
  "Search a category": "Search a category",
  "New on": "New on",
  "You got a free home delivery service":
    "You got a free home delivery service",
  "Instant Same Day Delivery": "Instant Same Day Delivery",
  "Send your parcel anywhere in country instantly & Safely":
    "Send your parcel anywhere in country instantly & Safely",
  "What are you sending ?": "What are you sending ?",
  "Parcel Delivery Information": "Parcel Delivery Information",
  "Sender Information": "Sender Information",
  "Receiver Information": "Receiver Information",
  "Sender Name": "Sender Name",
  "Pickup Address": "Pickup Address",
  "Sender Phone": "Sender Phone",
  "Set from map": "Set from map",
  "Add New Address": "Add New Address",
  "Saves Addresses": "Saves Addresses",
  "Street number": "Street number",

  "Parcel Info": "Parcel Info",
  "Proceed to Checkout": "Proceed to Checkout",
  "Sender name required": "Sender name required",
  "Receiver name required": "Receiver name required",
  "Sender phone required": "Sender phone required",
  "Receiver phone required": "Receiver phone required",
  "Delivery Information": "Delivery Information",
  Billing: "Billing",
  "Receiver Name": "Receiver Name",
  "Receiver Phone": "Receiver Phone",
  sender: "sender",
  "House no.": "House no.",
  "Floor no.": "Floor no.",
  Receiver: "Receiver",
  "Parcel Category": "Parcel Category",
  Distance: "Distance",
  Other: "Other",
  "Charge Paid By": "Charge Paid By",
  "Faster and safer way to send money": "Faster and safer way to send money",
  Send: "Send",

  "Confirm Parcel Request": "Confirm Parcel Request",
  "All Stores": "All Stores",
  "Take away": "Take away",
  "If you want to change store type, it will reset your cart and other related cache data.":
    "If you want to change store type, it will reset your cart and other related cache data.",
  Change: "Change",
  Location: "Location",
  "You must accept the terms and conditions":
    "You must accept the terms and conditions",
  "terms and conditions": "terms and conditions",
  "Available at": "Available at",
  to: "to",
  from: "from",
  "Minimum purchase": "Minimum purchase",
  "Maximum discount": "Maximum discount",
  Chat: "Chat",
  "Sender or Receiver location is missing":
    "Sender or Receiver location is missing",
  "please login first": "please login first",
  "Wallet balance is below total amount.":
    "Wallet balance is below total amount.",
  Color: "Color",
  "Buy Now": "Buy Now",
  "Similar Products": "Similar Products",
  Copy: "Copy",
  "No transaction found": "No transaction found",
  "insufficient amount": "insufficient amount",
  "You have item from another store in cart. If you continue, your all previous item from cart will be removed":
    "You have item from another store in cart. If you continue, your all previous item from cart will be removed",
  "Theme Settings": "Theme Settings",
  "Change language": "Change language",
  "Floor:": "Floor:",
  "Your Wishlist": "Your Wishlist",
  Products: "Products",
  Shops: "Shops",
  "Price Range": "Price Range",
  "Search for items...": "Search for items...",
  "Shipping policy": "Shipping policy",
  "Your cart has been cleared successfully. Now try to add the product again.":
    "Your cart has been cleared successfully. Now try to add the product again.",
  "items in your cart": "items in your cart",
  "No Favourite Items Found": "No Favourite Items Found",
  "No Favourite Stores Found": "No Favourite Stores Found",
  "You have nothing in your cart to checkout.":
    "You have nothing in your cart to checkout.",
  "Choose Your Interests": "Choose Your Interests",
  "Get personalized food recommendations.":
    "Get personalized food recommendations.",
  "Filter your search results": "Filter your search results",
  "Sort By": "Sort By",
  Ascending: "Ascending",
  "A to Z": "A to Z",
  Descending: "Descending",
  "Z to A": "Z to A",
  Price: "Price",
  "Filter By": "Filter By",
  "Forget password?": "Forget password?",
  "Welcome to React": "Welcome to React and react-i18next",
  Category: "Category",
  Email: "Email",
  Password: "Password",
  "Remember me": "Remember me",
  "Forgot Password": "Forgot Password",
  Login: "Login",
  "Want to login to your services ?": "Want to login to your services ?",
  "Login here": "Login here",
  Dashboard: "Dashboardd",
  "Collect Cash": "Collect Cash",
  "Open Confirm Dialog": "Open Confirm Dialog",
  "Confirm this request ? ": "Confirm this request ? ",
  Cancel: "Cancel",
  Yes: "Yes",
  Download: "Download",
  Filter: "Filter",
  "Zone Name": "Zone Name",
  Providers: "Providers",
  Services: "Services",
  Status: "Status",
  Action: "Action",
  "My Account": "My Account",
  Mails: "Mails",
  Notification: "Notifications",
  Restaurants: "Restaurants",
  Categories: "Categories",
  "SOME COMPONENTS": "SOME COMPONENTS",
  Components: "Components",
  Tables: "Tables",
  Alerts: "Alerts",
  Toasters: "Toasters",
  Dialogs: "Dialogs",
  "Form with formik": "Form with formik",
  Charts: "Charts",
  "Provider Details": "Provider Details",
  "Multistep Form With Steppers": "Multistep Form With Steppers",
  "SERVICE MANAGEMENT": "SERVICE MANAGEMENT",
  "Service Zones": "Service Zones",
  "Service Categories": "Service Categories",
  "Category Setup": "Category Setup",
  "Sub Category Setup": "Sub Category Setup",
  "Service List": "Service List",
  "Upload File": "Upload File",
  "On Demand Service": "On Demand Service",
  "Page not found": "Page not found",
  "Go Back Home": "Go Back Home",
  "Sign In": "Sign In",
  "Sign in to stay connected.": "Sign in to stay connected.",
  "Collect Cash From Provider": "Collect Cash From Provider",
  Edit: "Edit",
  "Information Details": "Information Details",
  "This field is required": "This field is required",
  "Payment Method": "Payment Method",
  "Name on card": "Name on card",
  "Card Number": "Card Number",
  Back: "Back",
  Next: "Next",
  "Review Your Order": "Review Your Order",
  "Shipping Address": "Shipping Address",
  "First Name": "First Name",
  "Last Name": "Last Name",
  Address: "Address",
  "Payment Details": "Payment Details",
  "Place Order": "Place Order",
  "Company / Individual name is required":
    "Company / Individual name is required",
  "Phone number is not valid": "Phone number is not valid",
  "Phone number is required": "Phone number is required",
  "Address is required": "Address is required",
  "File is required*": "File is required*",
  "Name is required": "Name is required",
  "Phone is required": "Phone is required",
  "Must be a valid email": "Must be a valid email",
  "Password is too short - should be 6 chars minimum.":
    "Password is too short - should be 6 chars minimum.",
  "Email is required": "Email is required",
  "No password provided.": "No password provided.",
  "Password is too short - should be 8 chars minimum.":
    "Password is too short - should be 8 chars minimum.",
  "Passwords must match": "Passwords must match",
  "Form With Formik": "Form With Formik",
  "General Information": "General Information",
  "Company / Individual Name": "Company / Individual Name",
  "Add New Provider": "Add New Provider",
  "Business Information": "Business Information",
  "Select Identity Type": "Select Identity Type",
  "Contact Person": "Contact Person",
  "Same as general information": "Same as general information",
  "Please upload your prescription image":
    "Please upload your prescription image",
  "Account Information": "Account Information",
  "Confirm Password": "Confirm Password",
  Submit: "Submit",
  Reset: "Reset",
  Contact: "Contact",
  Prescription: "Prescription",
  "Store Information": "Store Information",
  "Prescription Order": "Prescription Order",
  "Filter your order": "Filter your order",
  "Select Date Range": "Select Date Range",
  "Select Categories": "Select Categories",
  "Select  Sub Categories": "Select  Sub Categories",
  "Select  Zones": "Select  Zones",
  "Clear all Filter": "Clear all Filter",
  "Open Delete Dialog": "Open Delete Dialog",
  "Are Your Sure You Want to Delete This Zone ?":
    "Are Your Sure You Want to Delete This Zone ?",
  "This operation cannot be undone": "This operation cannot be undone",
  "No, Keep this ": "No, Keep this ",
  "Yes, Delete": "Yes, Delete",
  "Provider Details With Cards and Tabs":
    "Provider Details With Cards and Tabs",
  Search: "Search",
  Logout: "Logout",
  Overview: "Overview",
  "Subscribed Services": "Subscribed Services",
  Orders: "Orders",
  "Service Man List": "Service Man List",
  settings: "settings",
  "Edit Profile": "Edit Profile",
  "Add Address": "Add Address",
  Recommend: "Recommend",
  "Common Conditions!": "Common Conditions!",
  "My Addresses": "My Addresses",
  previous: "previous",
  "Earn money to your wallet by completing the offer & challenged":
    "Earn money to your wallet by completing the offer & challenged",
  "Convert your loyalty points into wallet money":
    "Convert your loyalty points into wallet money",
  "Send your wallet money while order": "Send your wallet money while order",
  "Admin also reward their top customers with wallet money":
    "Admin also reward their top customers with wallet money",
  ongoing: "ongoing",
  Reviews: "Reviews",
  "Edit Personal Details": "Edit Personal Details",
  "Update Profile": "Update Profile",
  Phone: "Phone",
  Name: "Name",
  "Identity Number": "Identity Number",
  "Rows Per Page": "Rows Per Page",
  Checkout: "Checkout",
  "Shipping address": "Shipping address",
  "Payment details": "Payment details",
  "Review your order": "Review your order",
  "First name is required": "First name is required",
  "Last name is required": "Last name is required",
  "Address Form": "Address Form",
  "items selected": "items selected",

  "Image Format - JPG, Pong, ZPEG, GIF Image Size - Maximum Size 2Mb Image Ratio - 1: 1":
    "Image Format - JPG, Pong, ZPEG, GIF Image Size - Maximum Size 2Mb Image Ratio - 1: 1",

  "Order ID": "Order ID",
  "Order Amount": "Order Amount",
  "Track Order": "Track Order",
  "track order": "track order",
  Pending: "Pending",
  pending: "pending",
  "More from Store": "More from Store",
  Home: "Home",
  "Features Catagories": "Features Catagories",
  Food: "Food",
  Campaigns: "Campaigns",
  "We provide best quality & fresh grocery items near your location":
    "We provide best quality & fresh grocery items near your location",
  "Best Reviewed Foods": "Best Reviewed Foods",
  "Special Offer": "Special Offer",
  "Most Popular Items": "Most Popular Items",
  "View all": "View all",
  "New On StackFood": "New On StackFood",
  "Popular Restaurants ": "Popular Restaurants",
  "Popular Food Nearby": "Popular Food Nearby",
  Nearby: "Nearby",
  "Chat with Seller": "Chat with Seller",
  "Best Resturants": "Best Resturants",
  "Filter by :": "Filter by :",
  "See more": "See more",
  All: "All",
  Veg: "Veg",
  "(Veg)": "(Veg)",
  "Non-Veg": "Non-Veg",
  "(Non-Veg)": "(Non-Veg)",
  "Sort Grid": "Sort Grid",
  "Sort by": "Sort by",
  "Your Favourites": "Your Favourites",
  "List view": "List view",
  Foods: "Foods",
  Found: "Found",
  view: "view",
  "Grid view": "Grid view",
  "View More": "View More",
  "We found": "We found",
  "foods for you": "foods for you",
  restaurants: "restaurants",
  "Best Reviewed": "Best Reviewed",
  "Sign in successfully.": "Sign in successfully.",
  food: "food",
  This: "This",
  "Available Form": "Available Form",
  "Fill details": "Fill details",
  Confirmation: "Confirmation",
  "is not available right now. You can order it later.":
    "is not available right now. You can order it later.",
  Description: "Description",
  "is not available right now.": "is not available right now.",
  "Add To Cart": "Add To Cart",
  "Total Amount": "Total Amount",
  "Add Ons (OPTIONAL)": "Add Ons (OPTIONAL)",
  "Select Variations": "Select Variations",
  "start from": "start from",
  "New Arrival Restaurants": "New Arrival Restaurants",
  Capacity: "Capacity",
  "Add to favorite": "Add to favorite",
  "Minimum Order Value": "Minimum Order Value",
  "Delivery Time": "Delivery Time",
  Ratings: "Ratings",

  Rating: "Rating",
  Offer: "Offer",
  "Expired on": "Expired on",
  Purchase: "Purchase",
  "Min purchase": "Min purchase",
  "Only for": "Only for",
  "Only for some specific zones": "Only for some specific zones",
  Restaurant: "Restaurant",
  Max: "Max",
  Code: "Code",
  "has been copied": "has been copied",
  Copied: "Code copied!",
  "Active Order": "Active Order",
  "Past Order": "Past Order",

  "Resturant Informations": "Resturant Informations",
  "Payment Status": "Payment Status",
  //"Order Status": "Order Status",
  Amount: "Amount",
  "Payment method": "Payment method",
  "Update To Cart": "Update To Cart",
  "order placed": "Order placed",
  //Order: "Order",
  "Follow us on": "Follow us on",
  "24/7 Helpline": "24/7 Helpline",
  "DELIVERY DETAILS": "DELIVERY DETAILS",
  "Delivery Options": "Delivery Options",
  "Home Delivery": "Home Delivery",
  "Take Away": "Take Away",
  "Preferable Time": "Preferable Time",
  "Already have an account?": "Already have an account?",
  "Don't have an account?": "Don't have an account?",
  Time: "Time",
  delivery: "delivery",
  Today: "Today",
  Tomorrow: "Tomorrow",
  Subtotal: "Subtotal",
  Discount: "Discount",
  "Payment Options": "Payment Options",
  "Cash on delivery": "Cash on delivery",
  "Digital Payment": "Digital Payment",
  "Wallet payment": "Wallet payment",
  Wallet: "Wallet",
  "cash on delivery": "cash on delivery",
  all: "all",
  "Active orders": "Active orders",
  "Past orders": "Past orders",
  " I agree that placing the order places me under Terms and Conditions & Privacy Policies":
    " I agree that placing the order places me under Terms and Conditions & Privacy Policies",
  "Have a Coupon?": "Have a Coupon?",
  "Apply Now": "Apply Now",
  "View Saved Address": "View Saved Address",
  "Delivery Address": "Delivery Address",
  " Add new address": " Add new address",
  "Add new address +": "Add new address +",
  " Add New +": " Add New +",
  "Address Type": "Address Type",
  "Newly Joined": "Newly Joined",

  New: "New",
  home: "Home",
  Office: "Office",
  Others: "Others",
  "Contact Person Name": "Contact Person Name",
  "Contact Person Number": "Contact Person Number",
  "Street Number": "Street Number",
  "Date & Time": "Date & Time",
  "Minimum 200 points required to convert into currency":
    "Minimum 200 points required to convert into currency",
  "Convert your loyalty point to wallet money.":
    "Convert your loyalty point to wallet money.",
  "Referrer Transactions": "Referrer Transactions",
  "Loyalty Points Transaction": "Loyalty Points Transaction",
  "Add Fund": "Add Fund",
  "Order Transaction": "Order Transaction",
  "All Transaction": "All Transaction",
  "Total Balance": "Total Balance",
  "Transaction Type": "Transaction Type",
  "Transaction History": "Transaction History",
  "AUTHENTIC ASIAN CUISINE": "AUTHENTIC ASIAN CUISINE",
  "BEST TACOS AROUND": "BEST TACOS AROUND",
  "Fast Home Delivery": "Fast Home Delivery",
  "DISCOUNT UPTO 20%": "DISCOUNT UPTO 20%",
  "for Chinese, Japanies & Asian foods": "for Chinese, Japanese & Asian foods",
  "Download our app from google play store & app store.":
    "Download our app from google play store & app store.",
  "I agree with the terms & conditions": "I agree with the terms & conditions",
  "Item added to cart": "Item added to cart",
  "You are not logged in": "You are not logged in",
  Free: "Free",
  "Login Information": "Login Information",
  "Owner Information": "Owner Information",
  "Delivery Man Image": "Delivery Man Image",
  "Loyalty Points !": "Loyalty Points !",
  "Search your desired foods ": "Search your desired foods ",
  "File upload": "file Upload",
  "Delivery Man Type": "Delivery Man Type",
  Zone: "Zone",
  "Identity Type": "Identity Type",
  "VAT/TEX": "VAT/TEX",
  "Restaurant Address": "Restaurant Address",
  "Restaurant Name": "Restaurant Name",
  "restaurant address required": "restaurant address required",
  "restaurant name required": "restaurant name required",
  "Minimum Delivery Time": "Minimum Delivery Time",
  Logo: "Logo",
  Items: "Items",
  "items for you !": "items for you !",
  "Store for you !": "Store for you !",
  items: "items",
  "Coupon Applied": "Coupon Applied",
  Paid: "Paid",

  Unpaid: "Unpaid",
  "Order Summery": "Order Summery",
  "Your food will be delivered within": "Your food will be delivered within",
  "Back to home": "Back to home",
  "Order Place Failed": "Order Place Failed",
  "Order didn't place successfully.": "Order didn't place successfully.",
  "Are you sure you want to cancel this order?":
    "Are you sure you want to cancel this order?",
  "Popular in this Restaurant!": "Popular in this Restaurant!",

  "Delivery man doesnt assigned": "Delivery man doesnt assigned",
  "Delivery man has not been assigned": "Delivery man has not been assigned",
  "Not Available now": "Not Available now",
  "Available will be": "Available will be",
  "non-veg": "non-veg",
  veg: "veg",

  "All Products": "All Products",
  "Positive Review": "Positive Review",
  "Delivering to": "Delivering to",
  Recommended: "Recommended",
  "Switch to cash on delivery": "Switch to cash on delivery",
  "Are you sure you want to switch this order to Cash On Delivery?":
    "Are you sure you want to switch this order to Cash On Delivery?",
  "Payment Failed": "Payment Failed",
  "My Orders": "My Orders",
  inbox: "inbox",
  "loyalty points": "loyalty points",
  "referral-code": "referral-code",
  coupons: "coupons",
  "profile settings": "profile settings",
  "my orders": "my orders",
  wallet: "wallet",
  " Change": " Change",
  "Added to favorite successfully.": "Added to favorite successfully.",
  "Removed from  favorite successfully.":
    "Removed from  favorite successfully.",
  "Something went wrong.": "Something went wrong.",
  Update: " Update",
  "Coupon Copied": "Coupon Copied",
  "Wallet Amount": "Wallet Amount",
  Language: "Language",
  "Identity number Is A Required Field": "Identity number Is A Required Field",
  "Delivery man image is required": "Delivery man image is required",
  "Logged in successfully": "Logged in successfully",
  "Additional Note": "Additional Note",
  "Terms & Conditions": "Terms & Conditions",
  "Privacy Policy": "Privacy Policy",
  "Quick Links": "Quick Links",
  "Contact Us": "Contact Us",
  "About Us": "About Us",
  " Loyalty Points": " Loyalty Points",
  "Only for First Order": "Only for First Order",
  "My account": "My account",
  Delivery: "Delivery",
  "No reviews found": "No reviews found",
  Guest: "Guest",
  "take away": "take away",
  "If you log in, your order history will be saved. However, if you continue as a guest, you won't be able to see your order history after completing your order.":
    "If you log in, your order history will be saved. However, if you continue as a guest, you won't be able to see your order history after completing your order.",
  "Do you want to login or continue as a guest?":
    "Do you want to login or continue as a guest?",
  "Please search some keywords.": "Please search some keywords.",
  "Are you sure you want to delete this address?":
    "Are you sure you want to delete this address?",
  "No food found": "No food found",
  "No restaurant found": "No restaurant found",
  "You cannot order from multiple restaurants in a single order":
    "You cannot order from multiple restaurants in a single order",
  "You have food from another restaurant in cart. If you continue, your all previous food from cart will be removed":
    "You have food from another restaurant in cart. If you continue, your all previous food from cart will be removed",
  "Are you sure, you want to reset?": "Are you sure, you want to reset?",
  "Please Choose a delivery address.": "Please Choose a delivery address.",
  "You denied location permission. Please allow browsers location permission from your device, refresh the site and receive more accurate delivery.":
    "You denied location permission. Please allow browsers location permission from your device, refresh the site and receive more accurate delivery.",
  Variation: "Variation",
  Addon: "Addon",
  "You place the order successfully.": "You place the order successfully.",
  "Your order is placed Successfully. We start our delivery process and you will receive your food soon":
    "Your order is placed Successfully. We start our delivery process and you will receive your food soon",
  "Congratulations!": "Congratulations!",
  "One or more item is not available for the chosen preferable schedule time.":
    "One or more item is not available for the chosen preferable schedule time.",
  "Download app to enjoy more!": "Download app to enjoy more!",
  "FIND BEST RESTAURANTS NEAR YOU": "FIND BEST RESTAURANTS NEAR YOU",
  "Pick Locations": "Pick Locations",
  "Best Reviewed Food": "Best Reviewed Food",
  "Need Any help?": "Need Any help?",
  "Communicate with our support team to get proper guidance to your quaternaries.":
    "Communicate with our support team to get proper guidance to your quaternaries.",
  "VISIT US": "VISIT US",
  "EMAIL US": "EMAIL US",
  "CALL US": "CALL US",
  "write something": "write something",
  "Restaurant Registration": "Restaurant Registration",
  "Logo is required": "Logo is required",
  "Cover photo is required": "Cover photo is required",
  "Please search a location first.": "Please search a location first.",
  "New location has been set.": "New location has been set.",
  "Popular Foods Nearby": "Popular Foods Nearby",
  "Please exchange more than": "Please exchange more than",
  points: "points",
  "Currently You don’t have any message selected.":
    "Currently You don’t have any message selected.",
  "Choose one from your existing messages, or start a new one.":
    "Choose one from your existing messages, or start a new one.",
  "Refer your code to your friends and get":
    "Refer your code to your friends and get",
  "for every referral!": "for every referral!",
  Messages: "Messages",
  Popular: "Popular",
  "Top Rated": "Top Rated",
  debit: "debit",
  credit: "credit",
  "No Favourite Restaurant Found": "No Favourite Restaurant Found",
  "No Favourite Food Found": "No Favourite Food Found",
  "Delivery man": "Delivery man",
  "Trip Route": "Trip Route",
  away: "away",
  "Order placed at": "Order placed at",
  "Search result for": "Search result for",
  "Enter phone number": "Enter phone number",
  "Free Delivery": "Free Delivery",
  "order refund": "order refund",
  "Please give an amount": "Please give an amount",
  referrer: "referrer",
  "Open Your Own Virtual Restaurant On": "Open Your Own Virtual Restaurant On",
  "Join as delivery man on": "Join as delivery man on",
  "Lets Connect !": "Lets Connect !",
  "Stay upto date with restaurants and foods around you":
    "Stay upto date with restaurants and foods around you",
  "Best Restaurants Near Your Location": "Best Restaurants Near Your Location",
  "Light Mode": "Light Mode",
  "Dark Mode": "Dark Mode",
  "Food Campaigns": "Food Campaigns",
  "All Restaurants": "All Restaurants",
  History: "History",
  "Total Orders": "Total Orders",
  Suggestions: "Suggestions",
  "Days Since Joining": "Days Since Joining",
  "amount in wallet": "amount in wallet",
  Coupons: "Coupons",
  Wallets: "Wallets",
  "Your Address": "Your Address",
  "Loyalty Points": "Loyalty Points",
  "Order placed ": "Order placed ",
  "Restaurant Information's": "Restaurant Information's",
  "Items Price": "Items Price",
  "Addons Price": "Addons Price",
  "Coupon Discount": "Coupon Discount",
  VAT: "VAT",
  "Delivery Fee": "Delivery Fee",
  "Share your opinion": "Share your opinion",
  "Rate the food": "Rate the food",
  Quantity: "Quantity",
  "Rate the deliveryman": "Rate the deliveryman",
  "I agree that placing the order places me under Terms and Conditions & Privacy Policies":
    "I agree that placing the order places me under Terms and Conditions & Privacy Policies",
  "Delivery Man Tips": "Delivery Man Tips",
  "It Will Add To Your Balance When The Order Is Delivered":
    "It Will Add To Your Balance When The Order Is Delivered",
  "You Have Earned Point": "You Have Earned Point",
  "Enjoy Off On All Foods": "Enjoy Off On All Foods",
  "Discount Available From": "Discount Available From",
  "Minimum Purchase Value": "Minimum Purchase Value",
  "Max Discount ": "Max Discount ",
  "Search foods in restaurant ": "Search foods in restaurant ",
  "Filter Your Search Results": "Filter Your Search Results",
  "Currently Available Items": "Currently Available Items",
  "Discounted Items": "Discounted Items",
  "Clear All Filter": "Clear All Filter",
  "Give a valid phone number to continue sign-in":
    "Give a valid phone number to continue sign-in",
  "ascending (A-Z)": "ascending (A-Z)",
  "descending (Z-A)": "descending (Z-A)",
  "Are You Sure You Want To Delete ?": "Are You Sure You Want To Delete ?",
  "Are You Sure You Want To Logout?": "Are You Sure You Want To Logout?",
  "Only for  Restaurant": "Only for  Restaurant",
  "Connect with our social media and other sites to keep up to date":
    "Connect with our social media and other sites to keep up to date",
  "% off": "% off",
  Register: "Register",
  "Use Current Location": "Use Current Location",
  Profile: "Profile",
  "Personal Info": "Personal Info",
  "Fast Name": "Fast Name",
  "Not changeable": "Not changeable",
  "Add New +": "Add New +",
  "Add new address": "Add new address",
  "Convert to currency now": "Convert to currency now",
  "Your loyalty point will convert to currency and transfer to wallet":
    "Your loyalty point will convert to currency and transfer to wallet",
  point: "point",
  "Your Profile": "Your Profile",
  "No Coupon Found": "No Coupon Found",
  "Search a restaurant": "Search a restaurant",
  "Closed Now": "Closed Now",
  Min: "Min",
  "% off on all foods": "% off on all foods",
  Enjoy: "Enjoy",
  "Discount available from": "Discount available from",
  "Search foods in restaurant": "Search foods in restaurant",
  Off: "Off",
  "Only For": "Only For",
  OFF: "OFF",
  "Days since Joining": "Days since Joining",
  "Amount in Wallet": "Amount in Wallet",

  "Delivery fee": "Delivery fee",
  "You have earned": "You have earned",
  "Minimum purchase value": "Minimum purchase value",
  "Max Discount": "Max Discount",

  "Cart is Empty": "Cart is Empty",
  "in your cart": "in your cart",
  min: "min",
  "Clear All": "Clear All",
  "Total Price": "Total Price",
  "Wallet balance is below total amount":
    "Wallet balance is below total amount",
  "Selected Address": "Selected Address",
  "Enter Your Coupon..": "Enter Your Coupon..",
  "Order Summary": "Order Summary",
  Total: "Total",
  "Restaurant Informations": "Restaurant Informations",
  "Give a review": "Give a review",
  "Cancel Order": "Cancel Order",
  "Order Confirmed": "Order Confirmed",
  "Preparing Food": "Preparing Food",
  "Food is on the way": "Food is on the way",
  Delivered: "Delivered",
  "Give Review": "Give Review",
  "Are you sure you want to  delete this item?":
    "Are you sure you want to  delete this item?",
  "Select And Start meaningful conversations!":
    "Select And Start meaningful conversations!",
  "Leave a message": "Leave a message",
  "Your order is placed Successfully. We start our delivery process and you will receive your food soon.":
    "Your order is placed Successfully. We start our delivery process and you will receive your food soon.",
  "point.": "point.",
  "It will add to your balance when the order is delivered.":
    "It will add to your balance when the order is delivered.",

  "You must be login to access this page.":
    "You must be login to access this page.",
  "You must pick a zone to access this page.":
    "You must pick a zone to access this page.",
  "Your Email": "Your Email",
  Join: "Join",
  "Please insert a valid email.": "Please insert a valid email.",
  "You must accept the": "You must accept the",
  "Terms and conditions": "Terms and conditions",
  "Forgot password?": "Forgot password?",
  "Sign Up": "Sign Up",
  "Refer Code (Optional)": "Refer Code (Optional)",
  "Send us mails": "Send us mails",
  "Find us here": "Find us here",
  "My Wallet": "My Wallet",
  "Become a restaurant owner": "Become a restaurant owner",
  "Become a delivery man": "Become a delivery man",
  "Help & Support": "Help & Support",
  "Open your own  virtual restaurant on":
    "Open your own  virtual restaurant on",
  "Are you sure you want to  logout?": "Are you sure you want to  logout?",
  "Clear Cart": "Clear Cart",
  "Order Now": "Order Now",
  "To select from saved addresses, you need to sign in.":
    "To select from saved addresses, you need to sign in.",
  "Location is required.": "Location is required.",
  Agree: "Agree",
  Okay: "Okay",
  Close: "Close",
  Favorites: "Favorites",
  "Pick from map": "Pick from map",
  Or: "Or",
  "Delivery Addresses": "Delivery Addresses",
  "VAT/TAX": "VAT/TAX",
  TAX: "TAX",
  "Add-on": "Add-on",
  "Maximum Delivery Time": "Maximum Delivery Time",
  "Cover Photo": "Cover Photo",
  Latitude: "Latitude",
  Longitude: "Longitude",
  "Confirm Password required": "Confirm Password required",
  "last name required": "last name required",
  "phone number required": "phone number required",
  "vat is required": "vat is required",
  "Identity Image": "Identity Image",
  "Password is required": "Password is required",
  Passport: "Passport",
  Nid: "Nid",
  FreeLancer: "FreeLancer",
  Salary: "Salary",
  "Signup successfully.": "Signup successfully.",
  "Please enter your register Mobile Number":
    "Please enter your register Mobile Number",
  Done: "Done",
  "field is empty": "field is empty",
  Verify: "Verify",
  take_away: "take_away",
  Delete: "Delete",
  Now: "Now",
  Schedule: "Schedule",
  Qty: "Qty",
  order_place: "order_place",
  loyalty_point: "loyalty_point",
  add_fund_by_admin: "add_fund_by_admin",
  point_to_wallet: "point_to_wallet",
  // pending: "pending",
  picked_up: "picked_up",
  accepted: "accepted",
  confirmed: "confirmed",
  canceled: "canceled",
  cash_on_delivery: "cash_on_delivery",
  delivered: "delivered",
  // "away":"away"
  Comment: "Comment",
  "You have no channels.": "You have no channels.",
  admin: "admin",
  "delivery man": "delivery man",
  vendor: "vendor",
  "Delete My Account": "Delete My Account",
  "Are you sure you want to delete your account?":
    "Are you sure you want to delete your account?",
  "Refund Request": "Refund Request",
  "Select an option": "Select an option",
  "Submit Refund Request": "Submit Refund Request",
  Note: "Note",
  "Please select a reason": "Please select a reason",
  "Maximum 3 images can be send at a time.":
    "Maximum 3 images can be send at a time.",
  "Attach photo": "Attach photo",
  "No saved addresses found to select.": "No saved addresses found to select.",
  "Deliveryman Registration": "Deliveryman Registration",
  foods: "foods",

  House: "House",
  "Payment Methods": "Payment Methods",
  "(Faster & secure way to pay bill)": "(Faster & secure way to pay bill)",
  Floor: "Floor",
  "House number": "House number",
  "No Data Found": "No Data Found",
  "No location found.": "No location found.",
  "Item updated successfully": "Item updated successfully",
  "Logged out successfully": "Logged out successfully",
  "No title given": "No title given",
  "Best reviewed Foods": "Best reviewed Foods",
  on: "on",
  "Language Changed Successfully.": "Language Changed Successfully.",
  "can not remain without selection.": "can not remain without selection.",
  "Refund Policy": "Refund Policy",
  "Shipping Policy": "Shipping Policy",
  "Cancellation Policy": "Cancellation Policy",
  "This Variation needs to be selected in between minimum":
    "This Variation needs to be selected in between minimum",
  "and maximum": "and maximum",
  "items.": "items.",
  "Enter the verification code (OTP) sent to":
    "Enter the verification code (OTP) sent to",

  "Selected variation named": "Selected variation named",
  "must be in between Minimum": "must be in between Minimum",
  "and Maximum": "and Maximum",
  "Add Ons (Optional)": "Add Ons (Optional)",
  "Social Register": "Social Register",
  "Social Login": "Social Login",
  "Continue with facebook": "Continue with facebook",
  "Password can not be updated while you are logged in by using social logins.":
    "Password can not be updated while you are logged in by using social logins.",
  "Previously added restaurant foods have been removed from cart. Now, try again.":
    "Previously added restaurant foods have been removed from cart. Now, try again.",
  "Order placement failed": "Order placement failed",
  "Order Placed Successfully": "Order placed successfully.",
  "Your payment has been successfully processed, and your order ":
    "Your payment has been successfully processed, and your order ",
  "has been placed.": "has been placed.",
  "If you accidentally provided incorrect payment information, you can edit the details in the order details section while the order is still pending.":
    "If you accidentally provided incorrect payment information, you can edit the details in the order details section while the order is still pending.",
  Get: "Get",
  "on joining": "on joining",
  "Earn money on every referral": "Earn money on every referral",
  "Refer your code to your friends": "Refer your code to your friends",
  "Tap to copy": "Tap to copy",
  "Your Referral Code": "Your Referral Code",
  "referral code": "referral code",
  "Referral code Copied": "Referral code Copied",
  "Search suggestions are loading...": "Search suggestions are loading...",
  "Your token has been expired.please sign in again":
    "Your token has been expired.please sign in again",
  "New On": "New On",
  "Deliveryman tips": "Deliveryman tips",
  "something went wrong.": "something went wrong.",
  "Please wait sometimes": "Please wait sometimes",
  "No Cuisine Restaurant Found": "No Cuisine Restaurant Found",
  "Cuisine Restaurant": "Cuisine Restaurant",
  Cuisines: "Cuisines",
  others: "others",
  office: "office",
  refund_requested: "refund_requested",
  popular_stores: "popular_stores",

  RecommendProduct: "RecommendProduct",
  "Cancel Reason": "Cancel Reason",
  "You can not Order more then 1000৳ on COD order":
    "You can not Order more then 1000৳ on COD order",
  WishList: "WishList",
  processing: "processing",
  refunded: "refunded",
  "refund requested": "refund requested",
  "refund requested canceled": "refund requested canceled",
  handover: "handover",
  "Explore Now": "Explore Now",
  "Start Exploring!": "Start Exploring!",
  "Select location first to start exploring shops & restaurants near you":
    "Select location first to start exploring shops & restaurants near you",
  Cart: "Cart",
  Store: "Store",
  We: "We",
  satisfied: "satisfied",
  "some Customer & Restaurant Owners": "some Customer & Restaurant Owners",
  "Become A Seller": "Become A Seller",
  "Register as seller and open shop in 6amMart to start your business":
    "Register as seller and open shop in 6amMart to start your business",
  "Become A Deliveryman": "Become A Deliveryman",
  "to start your business": "to start your business",
  "Register as seller and open shop in": "Register as seller and open shop in",
  "Register as delivery man and earn money":
    "Register as delivery man and earn money",
  "Lorem ipsum dolor sit amet, consectetur adipiscing elit.":
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
  "Let’s Start Earning with": "Let’s Start Earning with",
  "Campaign Schedule :": "Campaign Schedule :",
  "Daily time: ": "Daily time: ",
  "Popular Items Nearby": "Popular Items Nearby",
  "Running Campaigns": "Running Campaigns",
  "A store must be selected to continue":
    "A store must be selected to continue",
  "A module must be selected to continue.":
    "A module must be selected to continue.",
  "Please enter your registered mobile number":
    "Please enter your registered mobile number",
  "The total amount of the order, exceeds maximum amount of the cash on delivery method":
    "The total amount of the order, exceeds maximum amount of the cash on delivery method",
  "Select a type of module for your orders":
    "Select a type of module for your orders",

  "You have item from another store in cart. If you continue, your all previous item from cart will be removed and this one will be added.":
    "You have item from another store in cart. If you continue, your all previous item from cart will be removed and this one will be added.",
  "More products need to apply the coupon":
    "More products need to apply the coupon",
  "Terms And Conditions": "Terms And Conditions",
  "About us": "About us",
  "Cancellation policy": "Cancellation policy",
  "To apply this coupon, total order amount should be minimum":
    "To apply this coupon, total order amount should be minimum",
  "Point to wallet transfer successfully.":
    "Point to wallet transfer successfully.",
  "Item Price": "Item Price",
  "Vat/Tax (Included)": "Vat/Tax (Included)",
  Clear: "Clear",
  Included: "Included",
  "Saved Addresses": "Saved Addresses",
  "This variation is out of stock": "This variation is out of stock",
  "Free delivery": "Free delivery",
  "Store is closed. Try again later.": "Store is closed. Try again later.",
  "Restaurant is closed. Try again later.":
    "Restaurant is closed. Try again later.",
  "I agree that placing the order places me under":
    "I agree that placing the order places me under",
  "Terms and Conditions": "Terms and Conditions",
  "Subscribe to our weekly newsletter and be a part of our journey to self discovery and love.":
    "Subscribe to our weekly newsletter and be a part of our journey to self discovery and love.",
  "Join Us!": "Join Us!",
  "Recent Searches": "Recent Searches",
  "Quick View": "Quick View",
  "Visit Store": "Visit Store",
  "Add to wishlist": "Add to wishlist",
  "Remove from wishlist": "Remove from wishlist",
  "Visit Again": "Visit Again",
  "Just For You": "Just For You",
  "Shop Now": "Shop Now",
  "Item That You’ll Love": "Item That You’ll Love",
  "Join our online marketplace revolution and boost your income.":
    "Join our online marketplace revolution and boost your income.",
  "Loading...": "Loading...",
  "Language has been changed": "Language has been changed",
  "No module found": "No module found",
  "Contact with the site owner to activate modules.":
    "Contact with the site owner to activate modules.",
  "Google Play": "Google Play",
  "App Store": "App Store",
  "Seller App": "Seller App",
  "Deliveryman App": "Deliveryman App",
  "We are under maintainance.": "We are under maintainance.",
  "We will be back very soon.": "We will be back very soon.",
  Organic: "Organic",
  "Theme mode": "Theme mode",
  "What’s Wrong With This Order?": "What’s Wrong With This Order?",
  "Getting Order List...": "Getting Order List...",
  "Add Cutlery": "Add Cutlery",

  "Dont have a cutlery? Restaurant will provide you.":
    "Dont have a cutlery? Restaurant will provide you.",
    "If Any Product is not available": "If Any product is not available",
  "Remove it form my cart": "Remove it form my cart",
  "I will wait until it is restocked": "I will wait until it is restocked",
  "Please cancel the order": "Please cancel the order",
  "Call me ASAP": "Call me ASAP",
  "Fresh Item that deserve to eat": "Fresh Item that deserve to eat",
  "Exclusive collection for everyone": "Exclusive collection for everyone",
  "Quality Medicines & Health care at your Doorstep.":
    "Quality Medicines & Health care at your Doorstep.",
  "Get your groceries items delivered in less than an hour":
    "Get your groceries items delivered in less than an hour",
  "partially paid amount": "partially paid amount",
  "Notify me when it is back": "Notify me when it is back",
  "Remaining Wallet Balance": "Remaining Wallet Balance",

  "FIND YOUR HAPPINESS": "FIND YOUR HAPPINESS",
  "For the love of delicious food.": "For the love of delicious food.",

  "Deliver to the front door": "Deliver to the front door",
  "Deliver to the reception desk": "Deliver to the reception desk",
  "Avoid calling phone": "Avoid calling phone",
  "Come with no sound": "Come with no sound",
  Cutlery: "Cutlery",
  "Additional Charge": "Additional Charge",
  "Delivery instruction": "Delivery instruction",
  "Unavailable item note": "Unavailable item note",
  Deny: "Deny",
  Accept: "Accept",
  "Without any payment method, you can not place the order.":
    "Without any payment method, you can not place the order.",
  Subscribe: "Subscribe",
  "Nothing found": "Nothing found",
  Unit: "Unit",
  "In Stock": "In Stock",
  "Out of Stock": "Out of Stock",
  "Cancelled By": "Cancelled By",
  "Cancellation Reason": "Cancellation Reason",
  "Locate me": "Locate me",
  Explore: "Explore",
  "Are you sure to change the language?":
    "Are you sure to change the language?",
  "The browser will refresh to get translated content.":
    "The browser will refresh to get translated content.",
  No: "No",
  "We are under maintenance.": "We are under maintenance.",
  "added via": "added via",
  "Popular in this store!": "Popular in this store!",
  "Add to cart": "Add to cart",
  "Sort by : High to Low": "Sort by : High to Low",
  "Sort by : Low to High": "Sort by : Low to High",
  "Popular Tags": "Popular Tags",
  Brands: "Brands",
  bonus: "bonus",
  "1k+ km": "1k+ km",
  km: "km",
  "Upload your prescriptions here and get your medicine right at your door step":
    "Upload your prescriptions here and get your medicine right at your door step",
  "Upload Prescriptions": "Upload Prescriptions",
  "Need to order same medicine? don’t worry just click here":
    "Need to order same medicine? don’t worry just click here",
  "Refill Request": "Refill Request",
  "Visit Again!": "Visit Again!",
  "Get your recent medicine from the store you recently visited":
    "Get your recent medicine from the store you recently visited",
  "Get your recent purchase from the shop you recently visited":
    "Get your recent purchase from the shop you recently visited",
  "Complete Multipurpose": "Complete Multipurpose",
  eBusiness: "eBusiness",
  Solution: "Solution",
  "6amMart is a Laravel and Flutter Framework-based multi-vendor food, grocery, eCommerce, parcel, and pharmacy delivery system. It has six modules to cover all your business functionality.":
    "6amMart is a Laravel and Flutter Framework-based multi-vendor food, grocery, eCommerce, parcel, and pharmacy delivery system. It has six modules to cover all your business functionality.",
  "Featured Store": "Featured Store",
  "Close fullscreen": "Close fullscreen",
  Fullscreen: "Fullscreen",
  "CLOSED NOW": "CLOSED NOW",
  "Get Your Desired High Quality Products Here":
    "Get Your Desired High Quality Products Here",
  "Explore Items": "Explore Items",
  "Most Popular Products": "Most Popular Products",
  "We provide best quality & valuable products around the world":
    "We provide best quality & valuable products around the world",
  "Popular Store": "Popular Store",
  "Search foods and restaurants...": "Search foods and restaurants...",
  "Wanna Try  Again!": "Wanna Try  Again!",
  "Get your recent food from the restaurant you recently visited":
    "Get your recent food from the restaurant you recently visited",
  "Special Food Offers": "Special Food Offers",
  "Sorry no data found related to your search":
    "Sorry no data found related to your search",
  "Items not found!": "Items not found!",
  "Stores not found!": "Stores not found!",
  "More From This Store!": "More From This Store!",
  "Product Details": "Product Details",
  "Detail Description": "Detail Description",
  "Detailed Reviews": "Detailed Reviews",
  "Add fund": "Add fund",
  "Faster & secure way to pay bill": "Faster & secure way to pay bill",
  "Add fund by from secured digital payment gateways":
    "Add fund by from secured digital payment gateways",
  "Add Fund to Wallet": "Add Fund to Wallet",
  "If you want to add fund to your wallet then click add fund button":
    "If you want to add fund to your wallet then click add fund button",
  "Applied filters:": "Applied filters:",
  "The service": "The service",
  "you can rely on.": "you can rely on.",
  "from you": "from you",
  "Confirm Order": "Confirm Order",
  "No Contact Info Added": "No Contact Info Added",
  "Update Address": "Update Address",
  "Offline Payment! Now, with just a click of a button, you can make secure transactions. It's simple, convenient, and reliable.":
    "Offline Payment! Now, with just a click of a button, you can make secure transactions. It's simple, convenient, and reliable.",
  "Payment Info": "Payment Info",
  "Pay via Wallet": "Pay via Wallet",
  "% discount": "% discount",
  discount: "discount",
  "min Order of": "min Order of",
  "Select option from below": "Select option from below",
  "Pay your bill using any of the payment method below and input the required information in the form":
    "Pay your bill using any of the payment method below and input the required information in the form",
  "Paid By": "Paid By",
  Ok: "Ok",
  "Seller Payment Info": "Seller Payment Info",
  "My Payment Info": "My Payment Info",
  "Edit Info": "Edit Info",
  "Update Payment Info": "Update Payment Info",
  "Bank Info": "Bank Info",
  "Payment info updated.": "Payment info updated.",
  "Payment Denied": "Payment Denied",
  "Pay Offline": "Pay Offline",
  Applied: "Applied",
  "No Flash Sales Product Found!": "No Flash Sales Product Found!",
  "Internal server error": "Internal server error",
  "Try to ": "Try to ",
  "refresh ": "refresh ",
  "this page or go back to previous page":
    "this page or go back to previous page",
  "Go Back": "Go Back",
  "We Deliver Everything": "We Deliver Everything",
  "What are you wish to send?": "What are you wish to send?",
  "Easiest way to get services": "Easiest way to get services",
  "Add More Delivery Instruction": "Add More Delivery Instruction",
  "Choose Delivery Instructions": "Choose Delivery Instructions",
  "Or Add Custom Note": "Or Add Custom Note",
  "Add Custom Note": "Add Custom Note",
  Instructions: "Instructions",
  "Note must not be grater than 191 characters":
    "Note must not be grater than 191 characters",
  "Please enter your contact info": "Please enter your contact info",
  "Please select a paymrnt method": "Please select a paymrnt method",
  "Delete your account ?": "Delete your account ?",
  "Sorry you can’t delete your account !":
    "Sorry you can’t delete your account !",
  "You won’t be able to recover your data again":
    "You won’t be able to recover your data again",
  "Please complete your ongoing orders and ":
    "Please complete your ongoing orders and ",
  Remove: "Remove",
  "View My Orders": "View My Orders",
  "OR SHARE": "OR SHARE",
  "Hey there welcome to ": "Hey there welcome to ",
  "If you're checking out": "If you're checking out",
  "for the first time, make sure to use the referral code":
    "for the first time, make sure to use the referral code",
  "when you sign up. It's my way of welcoming you to this awesome e-commerce platform! Happy shopping on":
    "when you sign up. It's my way of welcoming you to this awesome e-commerce platform! Happy shopping on",
  "Hey there welcome to": "Hey there welcome to",
  "Someone just used  your code !": "Someone just used  your code !",
  "Be prepare to receive when they complete there first purchase":
    "Be prepare to receive when they complete there first purchase",
  Order: "Order",
  "Order Time": "Order Time",
  "Order Status": "Order Status",
  "Order Information :": "Order Information :",
  "Please allow browser location permission":
    "Please allow browser location permission",
  "Your browser location track permission is off. Please turn on the location permission to detect current location":
    "Your browser location track permission is off. Please turn on the location permission to detect current location",
  Save: "Save",
  "Invite and share your code to your friends & family members":
    "Invite and share your code to your friends & family members",
  "You made your earning when the order is complete":
    "You made your earning when the order is complete",
  "They create a account on 6amMart using your code and place their first order":
    "They create a account on 6amMart using your code and place their first order",
  "They create a account on": "They create a account on",
  "using your code and place their first order":
    "using your code and place their first order",
  "No Address Found": "No Address Found",
  Road: "Road",
  "Additional Information": "Additional Information",
  "Phone Number is required": "Phone Number is required",
  "Total points": "Total points",
  "No Orders Found": "No Orders Found",
  "Receiver Details": "Receiver Details",
  "Sender Details": "Sender Details",
  "Charge Pay By": "Charge Pay By",
  Payment: "Payment",
  Summary: "Summary",
  "No delivery man assigned": "No delivery man assigned",
  "delivery man info": "delivery man info",
  "seller info": "seller info",
  "See Chat History": "See Chat History",
  "Unit Price": "Unit Price",
  "How was your experience with your last order ?":"How was your experience with your last order ?",
  "Share us your valuable feedbacks":"Share us your valuable feedbacks",
  "Rate the item": "Rate the item",
  "Groceries": "Groceries",
  "Make sure to remember your ": "Make sure to remember your ",
  "order ID and phone number": "order ID and phone number",
  " that is used in this order as you have ordered as a guest user. Otherwise, you won’t be able to track your order in the future.": " that is used in this order as you have ordered as a guest user. Otherwise, you won’t be able to track your order in the future.",
  "Enter first name": "Enter first name",
  "Enter last name": "Enter last name",
  "Review": "Review",
  "Find What You Need": "Find What You Need",
  "Discover amazing products and stores": "Discover amazing products and stores",
  "Start exploring now": "Start exploring now",
};
